<app-header></app-header>
<section class="bredcrumb">
  <div class="container">
      <ul class="brd-nav">
          <li> <a [routerLink]="['/']"> Home </a></li>
          <li> <a [routerLink]="['/pharmacy/list']" *ngIf="!isBloodbank"> Pharmacy </a></li>
          <li> <a [routerLink]="['/blood/list']" *ngIf="!!isBloodbank"> Blood Bank </a></li>
          <li> <span>{{ pharmacyDetail.name }} </span></li>
      </ul>
  </div>
</section>
<!--- End of bredcrumb -->

<section class="single-page labs-detail doctors-detail padd-row">
  <div class="container">
      <div class="row">
          <div class="col-lg-4">
              <div class="doc-detail-lft grey-bg sidebar">
                  <div class="doc-detail-box btm-line mt-0 pt-0">
                      <div class="doctor-box-top">
                          <div style="cursor:pointer" (click)="showImagePopup(pharmacyDetail.profilePicture)" class="doctor-box-img">
                              <img [src]="pharmacyDetail.profilePicture" alt="image">
                          </div>
                          <div class="doctor-box-top-cnt">
                              <h5> {{ pharmacyDetail.name }} <span> {{!!isBloodbank ? 'Blood Bank' : 'Pharmacy'}} </span></h5>
                              <div class="doctor-box-rating">
                                  <i class="fa fa-star" aria-hidden="true"></i> <span> {{ !pharmacyDetail.averageRatings ? 0 : pharmacyDetail.averageRatings  }} | {{ pharmacyDetail?.review?.length }} Reviews </span>

                              </div>
                          </div>
                      </div>
                      <div class="hos-detail-adrs-top-sidebar btm-line">
                            <p> <strong> Address </strong></p>
                            <p><a target="_blank" 
                                [href]="'https://www.google.com/maps/place/'+pharmacyDetail?.address"> 
                                <i class="fa fa-map-marker" aria-hidden="true"></i>{{ pharmacyDetail?.address }}</a>  </p>
                            <!-- <p> <strong> Fees </strong></p>
                            <p> Rs. {{ hospitalDetail?.fees }}/- </p> -->
                            <p> <strong> Phone Number </strong></p>
                            <p> {{ pharmacyDetail?.phoneNo }}  
                                {{ pharmacyDetail?.alternateNumber ? '| '+pharmacyDetail?.alternateNumber : ''  }}

                                 </p>

                                 <p><strong> Timing</strong></p>
                                 <p [hidden]="single?.timing==''" *ngFor="let single of availability"> <i  class="fa fa-calendar-check-o" aria-hidden="true"></i>
                                    {{ single.timing }}
                                 </p>
                           
                        </div>
                      <!-- <div class="doc-detail-btm">
                          <ul>
                              <li> 
                                  <a target="_blank" [href]="'https://www.google.com/maps/place/'+pharmacyDetail.address"> 
                                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                                     {{ pharmacyDetail.address }}
                                    </a>
                                </li>
                              <li>Contact no: {{ pharmacyDetail.phoneNo }}</li>
                              <ng-template [ngIf]="availability.length>0" #avilability>
                              
                                <li [ngStyle]="{ 'color': single.error ? 'red' : 'none' }" [hidden]="single?.timing==''" *ngFor="let single of availability"> <i [ngStyle]="{ 'color': single.error ? 'red' : '#26abe3' }"  class="fa fa-calendar-check-o" aria-hidden="true"></i> {{ single.timing }} </li>
                              </ng-template>
                          </ul>
                      </div> -->
                  </div>
                  <div class="labs-details-images btm-line">
                      <h3> Images </h3>
                      <ul class="clearfix">
                          <li (click)="showImages()" *ngFor="let image of pharmacyDetail.images"> <img [src]="image" alt="image"> </li>
                          <!-- <li> <img src="assets/images/lab-detail-img-2.jpg" alt="image"> </li>
                          <li> <img src="assets/images/lab-detail-img-3.jpg" alt="image"> </li>
                          <li> <img src="assets/images/lab-detail-img-2.jpg" alt="image"> </li>
                          <li> <img src="assets/images/lab-detail-img-3.jpg" alt="image"> </li>
                          <li> <img src="assets/images/lab-detail-img-1.jpg" alt="image"> </li> -->
                      </ul>
                  </div>
                  <div *ngIf="pharmacyDetail?.review?.length>0" class="labs-reviews-sum">
                      <h3> Review Summary </h3>
                      <div class="labs-reviews-sum-prgs-bar">
                          <div class="lab-reviws-prgs-box">
                              <label> 5 </label>
                              <div class="progress">
                                  <div class="progress-bar" [style.width]="pharmacyDetail.starsCount_Five+'%'"></div>
                              </div>
                          </div>
                          <div class="lab-reviws-prgs-box">
                              <div class="progress">
                                  <label> 4 </label>
                                  <div class="progress-bar" [style.width]="pharmacyDetail.starsCount_Four+'%'"></div>
                              </div>
                          </div>
                          <div class="lab-reviws-prgs-box">
                              <div class="progress">
                                  <label> 3 </label>
                                  <div class="progress-bar" [style.width]="pharmacyDetail.starsCount_Three+'%'"></div>
                              </div>
                          </div>
                          <div class="lab-reviws-prgs-box">
                              <div class="progress">
                                  <label> 2 </label>
                                  <div class="progress-bar" [style.width]="pharmacyDetail.starsCount_Two+'%'"></div>
                              </div>
                          </div>
                          <div class="lab-reviws-prgs-box">
                              <div class="progress">
                                  <label> 1 </label>
                                  <div class="progress-bar" [style.width]="pharmacyDetail.starsCount_One+'%'"></div>
                              </div>
                          </div>
                      </div>
                      <!-- <ul>
                          <li *ngFor="let review of pharmacyDetail?.review?.reverse().slice(0,5)">
                              <img [src]="review?.userId?.profilePicture" alt="image">
                              <p> "{{ review?.comment }}." </p>
                          </li>

                      </ul> -->
                  </div>
              </div>
          </div>

          <div class="col-lg-8">
              <div class="doc-detail-nav">
                  <ul class="nav nav-pills">
                      <li class="nav-item">
                          <a class="nav-link active" data-toggle="pill"  (click)="scroll(target)" href="#pharmacy-details-1"> About </a>
                      </li>
                      <li class="nav-item" *ngIf="!isBloodbank">
                          <a class="nav-link" data-toggle="pill"  (click)="scroll(target1)" href="#pharmacy-details-2"> Upload Prescription </a>
                      </li>
                      <li *ngIf="pharmacyDetail?.review?.length>0" class="nav-item">
                          <a class="nav-link" data-toggle="pill"  (click)="scroll(target2)" href="#pharmacy-details-3"> Reviews </a>
                      </li>
                  </ul>
              </div>
              <div class="doc-detail-right tab-content">
                  <div #target class="tab-pane active" id="pharmacy-details-1j">
                      <div class="doc-detail-right-main">
                          <div class="doc-detail-cnt pt-0 btm-line">
                              <h3> About </h3>
                              <p class="mb-0"> {{ pharmacyDetail.about }}</p>
                          </div>

                      </div>
                  </div>
                  <div #target1 id="pharmacy-details-2j" *ngIf="!isBloodbank">
                      <div class="doc-detail-right-main">

                          <div class="upload-list-pharmacy doc-detail-cnt btm-line">
                              <h3> Upload Prescription </h3>
                              <div class="row">
                                  <div class="col-md-6">
                                      <div class="upload-list-lft">
                                          <input type="file" name="img" id="imageUpload-1" (change)="fileChanged($event)" accept=".png, .jpg, .jpeg" >
                                          <img src="assets/images/upload-file.png" alt="image">
                                          <h3> Drag & drop </h3>
                                          <h4> or <span> Browse </span> your files </h4>
                                      </div>
                                  </div>
                                  <div class="col-md-6">
                                      <div class="upload-list-rght">
                                          <div class="upload-list-files">
                                              <ul>
                                                  <li *ngFor="let booking of pharmacyUploadShow let i = index">
                                                      <div class="upload-list-file-box">
                                                          <img [src]="booking.image" alt="image">
                                                          <h4 class="clearfix"> Medicine List {{  i + 1  }} <i (click)="removeUpload(i)"  class="fa fa-times" aria-hidden="true"></i> </h4>
                                                          <!-- <p> {{ booking.size }} Mb </p> -->
                                                          <div class="progress">
                                                              <div class="progress-bar" style="width:100%"></div>
                                                          </div>
                                                      </div>
                                                  </li>

                                              </ul>
                                          </div>
                                          <div *ngIf="isImage" class="upload-list-btm-btns text-right">
                                              <a href="javascript://" class="btn-style btn-style-border"> Cancel </a>
                                              <a routeeLink="null"    (click)="loginFirst()"  class="btn-style"> Upload Prescription  </a>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>


                      </div>
                  </div>
                  <div  #target2  id="pharmacy-details-3j">
                      <div *ngIf="pharmacyDetail?.review?.length>0" class="doc-detail-right-main">


                          <div class="doc-detail-client-reviews doc-detail-cnt">
                              <h3> Reviews </h3>
                              <section class="our-customers">
                              <div class="our-customers-main">
                              <ngx-slick-carousel class="carousel"
                              #slickModal4="slick-carousel"
                              [config]="slideConfigCustomers"
          >
         
                <div *ngFor="let review of pharmacyDetail?.review" ngxSlickItem class="slider">
            <div class="our-customers-box_phar">
                <div class="client-review-box-img_phar">
                    <img [src]="review?.userId?.profilePicture" alt="image">
                </div>
                <div class="client-review-box-cnt_phar">
                    <h5> {{ review?.userId?.name }} </h5>
                    <p> "{{ review?.comment }}"</p>
                    <i *ngFor='let in of counter(review?.stars) ;let i = index' class="fa fa-star" aria-hidden="true"></i>
                              <i class="fa fa-star-o"   *ngFor='let in of counter(5- review?.stars) ;let i = index'  aria-hidden="true"></i> 
                   
                    <span> {{ !review.stars ? 0 : review.stars }} </span>
                </div>
                <!--div class="doctor-box-rating">
                      <i *ngFor='let in of counter(review?.stars) ;let i = index' class="fa fa-star" aria-hidden="true"></i>
                              <i class="fa fa-star-o"   *ngFor='let in of counter(5- review?.stars) ;let i = index'  aria-hidden="true"></i> 
                   
                    <span> {{ !review.stars ? 0 : review.stars }} </span>
                   
                </div-->
            </div>
                 </div>
        
        </ngx-slick-carousel>
        </div>
        </section>
                            
                            </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- End of doctors-detail -->

<input type="hidden" #closeconfirmation data-toggle="modal" id="order_confirm" data-target="#order_confirmed_pharmecy">

    <!-- The Modal -->
    <div class="modal fade" id="order_confirmed_pharmecy">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">

                <!-- Modal body -->
                <div class="modal-body">
                    <div class="sign-up-form order-confirmed">
                        <h2 class="text-center"> <span> Order Confirmed </span> </h2>
                        <h5> Congratulations! Your order is confirmed. </h5>
                        <h5> You Can review your order </h5>
                        <a (click)="gotoUserOrders()" class="btn-style" routerLink="null"> Ok </a>
                    </div>
                </div>
            </div>
        </div>
    </div>




<input type="hidden"  data-toggle="modal" id="address_pharmacy" data-target="#order-address">

<div class="modal fade" data-backdrop="static" id="order-address">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <!-- Modal body -->
            <div class="modal-body">
                <div class="sign-up-form add-doc-form">
                    <div class="add-doc-ambu-cmn add-treat-form">
                        <h2> Add Address </h2>
                        <form class="doctors-edit-main p-0 no-shadow">
                            <div class="doctors-edit-lft">
                                <div class="edit-profile-form-rows">
                                    <div class="row no-gutters">
                                        <div class="col-md-12">
                                            <label> Address </label>
                                            <input type="text" name="user_address" id="user_address_lab"   (keypress)="checkAddress()"  (onAddressChange)="handleAddressChange($event)" [options]='options'  ngx-google-places-autocomplete  #placesRef="ngx-places"    [(ngModel)]="addressFields.address" class="form-control" placeholder="Enter Your Address">

                                        </div>
                                        <div class="col-md-12">
                                                <div id="mapLocation"></div>
                                                <div class="centerMarker"></div>
                                              </div>
                                        <div class="col-md-12">
                                            <label> City </label>
                                            <input type="text" name="user_city" id="user_city_lab" class="form-control" [(ngModel)]="addressFields.city" placeholder="Enter City">
                                        </div>
                                         <!-- <ejs-datetimepicker [min]='minDateValue' [minuteStep]="30" id='datetimepicker' placeholder='Select  Date & Time...' name="dateTime" format ='dd MMM,yyyy  HH:mm a' [(ngModel)]='valueDate' ></ejs-datetimepicker> -->
                                            <!-- <p-calendar class="form-control"   [minDate]="minDateValue"  [(ngModel)]="valueDate" name="datebook" [stepMinute]=30 dateFormat="dd M yy" [showTime]="true" [hourFormat]="12"></p-calendar> -->
                                        <!-- <div class="col-md-6" style="margin-top:26px">
                                                <input class="form-control"
                                                placeholder="Select Date"
                                                ngModel
                                                name="datebook"
                                                bsDatepicker
                                                #dp="bsDatepicker"
                                                [minDate]="minDateValue"
                                                [bsConfig]="{ dateInputFormat: 'MMMM Do YYYY' }"
                                                [(bsValue)]="valueDate"
                                               >
                                           
                                         </div>
                                         <div class="col-md-6">
                                                <timepicker minuteStep="30" (ngModelChange)="changed()" name="booktime" class="time_lab" [(ngModel)]="valueTime"
                                               ></timepicker>
                                         </div> -->

                                        <div class="col-md-12">
                                            <div class="add-doc-btns-btm mt-3">
                                                <!-- <button type="submit"    class="btn-style no-shadow"> Save </button>
                                                <button type="button"  class="btn-style btn-style-grey  no-shadow" data-dismiss="modal"> Cancel </button> -->
                                                <button [disabled]="addressFields.address=='' || addressFields.city==''" (click)="bookPharmacy()" class="btn-style no-shadow"> 
                                                    Book {{!!isBloodbank ? 'Blood Bank' : 'Pharmacy'}} 
                                                </button>
                                                <a href="javascript://" class="btn-style btn-style-grey  no-shadow" (click)="removePharmacyData()" data-dismiss="modal"> Cancel </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>




<input type="hidden" id="orderImagesCLick" data-toggle="modal" data-target="#orderImagesModal">

<!-- The Modal -->
<div class="modal fade"  id="orderImagesModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Image Preview</h5>
      </div>
      <!-- Modal body -->
      <div class="modal-body text-center">
            <slideshow
            [minHeight]="'525px'"
            [showArrows]="imageUrlArray.length>1 ? true: false"
            [imageUrls]="imageUrlArray"></slideshow>
        <button class="btn btn-primary" style="margin-top: 20px;"
 data-toggle="modal" data-target="#orderImagesModal">OK</button>

      </div>
    </div>
  </div>
</div>
